import { getAccounts } from '../../../services/stockJournal/account';

export default {
    namespaced: true,
    state: {
        accounts: [],
    },
    getters: {
        accounts: state => state.accounts.filter(account => account.is_active == 1),
        userAccounts: (state, getters, rootState) => {
            let userAccountsIDs = rootState.stockJournal.userAccountsIDs;
            return state.accounts.filter(each => userAccountsIDs.includes(each.id))
        },
    },
    mutations: {
        setAccounts: (state, payload) => state.accounts = payload,
    },
    actions: {
        fetchAccounts: (context) => {
            return new Promise((resolve, reject) => {
                getAccounts({scope: "all"})
                    .then(response => {
                        context.commit("setAccounts", response.data);
                        resolve(response);
                    }).catch(error => reject(error));
            });
        }
    }
}